import React from "react";
import { useNavigate } from "react-router-dom";

const InfoPage = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            minHeight: '100vh',
            backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/SQUASHMOODSWING%20-%20SIDE%20A.00_20_47_08.Still048.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            position: 'relative'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 0
            }}></div>
            <div className="login-format" style={{ padding: "20px", textAlign: "center", cursor: "default", position: 'relative', zIndex: 1 }}>
                <div style={{ width: "fit-content", margin: "0 auto", maxWidth: "600px" }}>
                    <h1 style={{ marginBottom: "30px", cursor: "default" }}>Info</h1>
                    <div style={{ textAlign: "left", marginBottom: "30px" }}>
                        <p style={{ marginBottom: "20px", fontSize: "16px", lineHeight: "1.6", cursor: "default" }}>
                            Dig Assistant is the taste of Timehri encodified. Dig through vinyl with the Timehri lens.
                        </p>
                        <p style={{ marginBottom: "20px", fontSize: "16px", lineHeight: "1.6", cursor: "default" }}>
                            Explore over 50 million vinyl across Rock, Soul, Funk, Dub, Techno, House, Jungle, HipHop, Post-Punk and many more.
                        </p>
                        <ul style={{ marginBottom: "20px", paddingLeft: "20px", fontSize: "16px", lineHeight: "2", cursor: "default" }}>
                            <li style={{ marginBottom: "10px" }}>
                                Submit a Discogs release URL to surface related records, then dive to explore deeper connections.<br />
                                <span style={{ opacity: 0.6, fontSize: "14px" }}>e.g. </span>
                                <a
                                    href="https://www.discogs.com/release/2111-UR-The-Final-Frontier"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#009e4a', textDecoration: 'underline', fontSize: "14px" }}
                                >
                                    https://www.discogs.com/release/2111-UR-The-Final-Frontier
                                </a>
                            </li>
                            <li style={{ marginBottom: "10px" }}>
                                In voyage mode simply describe something you already like e.g:
                                <ul style={{ marginTop: "8px", paddingLeft: "20px", lineHeight: "2" }}>
                                    <li><em>"Underground Resistance - The Final Frontier"</em></li>
                                    <li><em>"Early 80s Peter Tosh"</em></li>
                                    <li><em>"Late 90s UKG like on Nice N Ripe"</em></li>
                                </ul>
                                <p style={{ marginTop: "8px", fontSize: "14px", opacity: 0.6 }}>
                                    The more specific you are the better, artist, era, style, label, country etc
                                </p>
                            </li>
                        </ul>
                        <p style={{ marginBottom: "20px", fontSize: "16px", lineHeight: "1.6", cursor: "default" }}>
                            Deep cuts represent super recs for that search
                        </p>
                    </div>
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            background: 'none',
                            border: '1px solid #009e4a',
                            color: '#009e4a',
                            padding: '12px 24px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontFamily: 'CustomFont',
                            fontSize: '16px',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.background = '#009e4a';
                            e.target.style.color = 'black';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = 'none';
                            e.target.style.color = '#009e4a';
                        }}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InfoPage;

